export default "__VITE_ASSET__C7__TBbQ__"